<input
  type="text"
  class="table-input-field"
  (blur)="onBlur()"
  [(ngModel)]="selectedValue"
  (keyup.enter)="onBlur()"
  [disabled]="isInputDisabled"
/>
